module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.status.status_label')))]), _vm._v(" "), _c('th', {
    staticClass: "monitoringAlignRight"
  }, [_vm._v(_vm._s(_vm.$t('common.only_number')))]), _vm._v(" "), _c('th', {
    staticClass: "monitoringAlignRight"
  }, [_vm._v(_vm._s(_vm.$t('common.amnt')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(status) {
    return (_vm.showOnThisService(status.service)) ? _c('tr', {
      staticClass: "boxRequest",
      on: {
        "click": function($event) {
          return _vm.filterSendBox(status.redirectionParameter)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "padding-right": "0px"
      }
    }, [_c('i', {
      staticClass: "icon icon-monitoring-table",
      class: status.icon
    }), _vm._v(" " + _vm._s(_vm.$t(status.label)) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "monitoringAlignRight",
      attrs: {
        "id": status.id
      }
    }, [_vm._v(_vm._s(_vm.commonfunctions.parseFloatOrInt(_vm.statusValues(status.dataAccessParameter).number)))]), _vm._v(" "), _c('td', {
      staticClass: "monitoringAlignRight"
    }, [_vm._v(_vm._s(_vm.commonfunctions.parseFloatOrInt(_vm.statusValues(status.dataAccessParameter).amount)) + " €")])]) : _vm._e()
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0668df6c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0668df6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/monitoringTable/monitoringTable.vue
// module id = 1612
// module chunks = 2